import DesktopForgottenPassword from './DesktopForgottenPassword';
export default DesktopForgottenPassword;
